import { render, staticRenderFns } from "./CollectionInviteQrCodeModal.vue?vue&type=template&id=a8ece804&"
import script from "./CollectionInviteQrCodeModal.vue?vue&type=script&lang=js&"
export * from "./CollectionInviteQrCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports